import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzRfnd3Nd } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_RFND3_ND: Record<
  Exclude<PageIdWoofzRfnd3Nd, PageIdWoofzRfnd3Nd.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SEX_RFND3_ND]: {
    id: PageId.SEX_RFND3_ND,
    hasHeader: true,
    progressBarHidden: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_AGE_RFND3_ND]: {
    id: PageId.DOG_AGE_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_RFND3_ND]: {
    id: PageId.DOG_BREED_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_RFND3_ND]: {
    id: PageId.URGE_RFND3_ND,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.COMMANDS_61_RFND3_ND]: {
    id: PageId.COMMANDS_61_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_62_RFND3_ND]: {
    id: PageId.COMMANDS_62_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_63_RFND3_ND]: {
    id: PageId.COMMANDS_63_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_RFND3_2_ND]: {
    id: PageId.URGE_RFND3_2_ND,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.POTTY_RFND3_ND]: {
    id: PageId.POTTY_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_RFND3_ND]: {
    id: PageId.BEHAVIOR_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_RFND3_ND]: {
    id: PageId.TRAINING_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.PREPARE_FLOW_RFND3_ND]: {
    id: PageId.PREPARE_FLOW_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageId.DOG_STATISTICS_RFND3_ND]: {
    id: PageId.DOG_STATISTICS_RFND3_ND,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.EMAIL_RFND3_ND]: {
    id: PageId.EMAIL_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageId.NEWSLETTER_URGE_RFND3_ND]: {
    id: PageId.NEWSLETTER_URGE_RFND3_ND,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageId.LAST_CHANCE_OFFER_RFND3_ND]: {
    id: PageId.LAST_CHANCE_OFFER_RFND3_ND,
  },
  [PageId.SUBSCRIPTIONS_RFND3_ND]: {
    id: PageId.SUBSCRIPTIONS_RFND3_ND,
  },
  [PageId.CANCEL_OFFER_RFND3_ND]: {
    id: PageId.CANCEL_OFFER_RFND3_ND,
  },
  [PageId.CHAT_UPSELL_RFND3_ND]: {
    id: PageId.CHAT_UPSELL_RFND3_ND,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_RFND3_ND]: {
    id: PageId.UPSELL_RFND3_ND,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_RFND3_ND]: {
    id: PageId.DOWNLOAD_RFND3_ND,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
